import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between px-2 py-1" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createBlock(_component_v_input, {
    ref: "root",
    "model-value": _ctx.modelValue,
    rules: _ctx.validationRules,
    "hide-details": ""
  }, {
    default: _withCtx(({ isValid }) => [
      _createVNode(_component_v_field, {
        variant: "outlined",
        density: "compact",
        color: "primary",
        label: _ctx.label,
        active: "",
        focused: _ctx.isFocused,
        dirty: _ctx.hasAnyValue,
        error: isValid.value === false,
        clearable: _ctx.clearable && _ctx.hasAnyValue,
        "onClick:clear": _ctx.clearValue
      }, {
        "prepend-inner": _withCtx(() => [
          _createVNode(_component_v_menu, {
            modelValue: _ctx.menu,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.menu) = $event)),
            "close-on-content-click": false,
            transition: "scale-transition",
            location: "bottom start",
            "min-width": "auto"
          }, {
            activator: _withCtx(({ props: menuProps }) => [
              _createVNode(_component_v_icon, _mergeProps(menuProps, {
                icon: "mdi-calendar",
                class: "cursor-pointer"
              }), null, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_locale_provider, { locale: "en" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    ref: "pickerCard",
                    elevation: "4",
                    class: "d-inline-block rounded-lg date-picker-card",
                    style: {"max-width":"328px"},
                    tabindex: "0",
                    onKeydown: _ctx.onPickerKeydown
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_date_picker, {
                        "model-value": _ctx.pendingAsDate,
                        month: _ctx.pickerMonth,
                        year: _ctx.pickerYear,
                        "hide-header": "",
                        color: "primary",
                        elevation: "0",
                        "onUpdate:modelValue": _ctx.onPickerSelect,
                        "onUpdate:month": _cache[0] || (_cache[0] = ($event: any) => (_ctx.pickerMonth = $event)),
                        "onUpdate:year": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pickerYear = $event))
                      }, null, 8, ["model-value", "month", "year", "onUpdate:modelValue"]),
                      _createVNode(_component_v_divider),
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          color: "primary",
                          size: "small",
                          onClick: _ctx.onClearClick
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("Clear", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          color: "primary",
                          size: "small",
                          onClick: _ctx.onTodayClick
                        }, {
                          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                            _createTextVNode("Today", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onKeydown"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "date-segments",
            onMousedown: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onContainerMousedown && _ctx.onContainerMousedown(...args)))
          }, [
            _createElementVNode("input", {
              ref: "day",
              value: _ctx.day,
              class: "date-segment date-segment--dm",
              type: "text",
              inputmode: "numeric",
              maxlength: "2",
              placeholder: "DD",
              autocomplete: "off",
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onInput('day', $event))),
              onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onKeydown('day', $event))),
              onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSegmentFocus && _ctx.onSegmentFocus(...args))),
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSegmentBlur('day')))
            }, null, 40, _hoisted_2),
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "date-separator" }, "/", -1)),
            _createElementVNode("input", {
              ref: "month",
              value: _ctx.month,
              class: "date-segment date-segment--dm",
              type: "text",
              inputmode: "numeric",
              maxlength: "2",
              placeholder: "MM",
              autocomplete: "off",
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onInput('month', $event))),
              onKeydown: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onKeydown('month', $event))),
              onFocus: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSegmentFocus && _ctx.onSegmentFocus(...args))),
              onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSegmentBlur('month')))
            }, null, 40, _hoisted_3),
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "date-separator" }, "/", -1)),
            _createElementVNode("input", {
              ref: "year",
              value: _ctx.year,
              class: "date-segment date-segment--y",
              type: "text",
              inputmode: "numeric",
              maxlength: "4",
              placeholder: "YYYY",
              autocomplete: "off",
              onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onInput('year', $event))),
              onKeydown: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onKeydown('year', $event))),
              onFocus: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onSegmentFocus && _ctx.onSegmentFocus(...args))),
              onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSegmentBlur('year')))
            }, null, 40, _hoisted_4)
          ], 32)
        ]),
        _: 1
      }, 8, ["label", "focused", "dirty", "error", "clearable", "onClick:clear"])
    ]),
    _: 1
  }, 8, ["model-value", "rules"]))
}